/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lessons_Format_Private_TitleInputs */

const en_lessons_format_private_title = /** @type {(inputs: Lessons_Format_Private_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Private Lesson`)
};

const es_lessons_format_private_title = /** @type {(inputs: Lessons_Format_Private_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clase privada`)
};

const de_lessons_format_private_title = /** @type {(inputs: Lessons_Format_Private_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einzelstunde`)
};

const zh_lessons_format_private_title = /** @type {(inputs: Lessons_Format_Private_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`私人课程`)
};

const ar_lessons_format_private_title = /** @type {(inputs: Lessons_Format_Private_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`درس خاص`)
};

const fr_lessons_format_private_title = /** @type {(inputs: Lessons_Format_Private_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leçon particulière`)
};

const vi_lessons_format_private_title = /** @type {(inputs: Lessons_Format_Private_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buổi học riêng`)
};

const sw_lessons_format_private_title = /** @type {(inputs: Lessons_Format_Private_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Somo la Kibinafsi`)
};

const th_lessons_format_private_title = /** @type {(inputs: Lessons_Format_Private_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บทเรียนส่วนตัว`)
};

const bs_lessons_format_private_title = /** @type {(inputs: Lessons_Format_Private_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Individualni čas`)
};

const ja_lessons_format_private_title = /** @type {(inputs: Lessons_Format_Private_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プライベートレッスン`)
};

const ko_lessons_format_private_title = /** @type {(inputs: Lessons_Format_Private_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`개인 레슨`)
};

const pt_lessons_format_private_title = /** @type {(inputs: Lessons_Format_Private_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aula particular`)
};

const it_lessons_format_private_title = /** @type {(inputs: Lessons_Format_Private_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lezione privata`)
};

const sv_lessons_format_private_title = /** @type {(inputs: Lessons_Format_Private_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privatlektion`)
};

const nl_lessons_format_private_title = /** @type {(inputs: Lessons_Format_Private_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privéles`)
};

const da_lessons_format_private_title = /** @type {(inputs: Lessons_Format_Private_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privatlektion`)
};

const nb_lessons_format_private_title = /** @type {(inputs: Lessons_Format_Private_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privat leksjon`)
};

const fi_lessons_format_private_title = /** @type {(inputs: Lessons_Format_Private_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yksityisopetus`)
};

const pl_lessons_format_private_title = /** @type {(inputs: Lessons_Format_Private_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lekcja prywatna`)
};

const ru_lessons_format_private_title = /** @type {(inputs: Lessons_Format_Private_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Индивидуальный урок`)
};

const tr_lessons_format_private_title = /** @type {(inputs: Lessons_Format_Private_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Özel Ders`)
};

const hi_lessons_format_private_title = /** @type {(inputs: Lessons_Format_Private_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निजी पाठ`)
};

const id_lessons_format_private_title = /** @type {(inputs: Lessons_Format_Private_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les Privat`)
};

const ms_lessons_format_private_title = /** @type {(inputs: Lessons_Format_Private_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajaran Persendirian`)
};

const cs_lessons_format_private_title = /** @type {(inputs: Lessons_Format_Private_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soukromá lekce`)
};

const el_lessons_format_private_title = /** @type {(inputs: Lessons_Format_Private_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ιδιωτικό μάθημα`)
};

const he_lessons_format_private_title = /** @type {(inputs: Lessons_Format_Private_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שיעור פרטי`)
};

const af_lessons_format_private_title = /** @type {(inputs: Lessons_Format_Private_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privaatles`)
};

const hu_lessons_format_private_title = /** @type {(inputs: Lessons_Format_Private_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privát lecke`)
};

/**
* | output |
* | --- |
* | "Private Lesson" |
*
* @param {Lessons_Format_Private_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const lessons_format_private_title = /** @type {((inputs?: Lessons_Format_Private_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lessons_Format_Private_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_lessons_format_private_title(inputs)
	if (locale === "de") return de_lessons_format_private_title(inputs)
	if (locale === "zh") return zh_lessons_format_private_title(inputs)
	if (locale === "ar") return ar_lessons_format_private_title(inputs)
	if (locale === "fr") return fr_lessons_format_private_title(inputs)
	if (locale === "vi") return vi_lessons_format_private_title(inputs)
	if (locale === "sw") return sw_lessons_format_private_title(inputs)
	if (locale === "th") return th_lessons_format_private_title(inputs)
	if (locale === "bs") return bs_lessons_format_private_title(inputs)
	if (locale === "ja") return ja_lessons_format_private_title(inputs)
	if (locale === "ko") return ko_lessons_format_private_title(inputs)
	if (locale === "pt") return pt_lessons_format_private_title(inputs)
	if (locale === "it") return it_lessons_format_private_title(inputs)
	if (locale === "sv") return sv_lessons_format_private_title(inputs)
	if (locale === "nl") return nl_lessons_format_private_title(inputs)
	if (locale === "da") return da_lessons_format_private_title(inputs)
	if (locale === "nb") return nb_lessons_format_private_title(inputs)
	if (locale === "fi") return fi_lessons_format_private_title(inputs)
	if (locale === "pl") return pl_lessons_format_private_title(inputs)
	if (locale === "ru") return ru_lessons_format_private_title(inputs)
	if (locale === "tr") return tr_lessons_format_private_title(inputs)
	if (locale === "hi") return hi_lessons_format_private_title(inputs)
	if (locale === "id") return id_lessons_format_private_title(inputs)
	if (locale === "ms") return ms_lessons_format_private_title(inputs)
	if (locale === "cs") return cs_lessons_format_private_title(inputs)
	if (locale === "el") return el_lessons_format_private_title(inputs)
	if (locale === "he") return he_lessons_format_private_title(inputs)
	if (locale === "af") return af_lessons_format_private_title(inputs)
	if (locale === "hu") return hu_lessons_format_private_title(inputs)
	return en_lessons_format_private_title(inputs)
});